(function (Drupal, $) {
  'use strict';

  Drupal.behaviors.stickyHeader = {

    attach: function attach(context) {
      const scrollCheck = () => {
        const scrollTopWindow = $(window).scrollTop();
        const elementOffset = $('.layout-container').offset().top;

        if (scrollTopWindow > elementOffset) {
          $('header').addClass('sticky');
        } else {
          $('header').removeClass('sticky');
        }
      };

      $(window).scroll(scrollCheck);
      $(window).ready(scrollCheck);

      const mobMenu = document.querySelector('[data-region="mobile_header"]');
      const btnAbout = document.getElementById("back-about-us");

      // Desktop menu
      $('.layout__region--header .block-menu-block-dennys-mainnavigation .dropdown-item').click(function (e) {
        // Aria for accessibility
        if($(this).attr('aria-expanded') === 'true') {
          $(this).attr('aria-expanded', 'false');
        } else {
          $(this).attr('aria-expanded', 'true');
        }
        $('.layout__region--header').toggleClass('dropdown-open');
        e.preventDefault();
        return false;
      });
      // Mobile Menu
      $('.layout__region--mobile-header .dropdown-item, .layout__region--mobile-header .back').click(function (e) {
        // Aria for accessibility
        if($('.layout__region--mobile-header .dropdown-item').attr('aria-expanded') === 'true') {
          $('.layout__region--mobile-header .dropdown-item').attr('aria-expanded', 'false');
        } else {
          $('.layout__region--mobile-header .dropdown-item').attr('aria-expanded', 'true');
        }
        $('.layout__region--mobile-header').toggleClass('dropdown-open');
        e.preventDefault();
        return false;
      });
      // Accessibility
      $('#burger-menu, .header__sign-in').click(function (e) {
        mobMenu.focus();
        e.preventDefault();
        return false;
      });
      // Accessibility
      $('#burger-close-button').click(function (e) {
        e.preventDefault();
        return false;
      });
      // Accessibility
      $(btnAbout).click(function (e) {
        mobMenu.focus();
        e.preventDefault();
        return false;
      });

      const observer = new IntersectionObserver((entries) => {
        if(entries[0].isIntersecting){
          btnAbout.focus();
        } else {}
      });
      observer.observe(btnAbout);
    }
  };
})(Drupal, jQuery);
